import { BottomTabBar } from "@/components/BottomTabBar";

/**
 * MobileShell — Centered phone-width frame on desktop; full-bleed on mobile.
 * Matches the mobile app's chrome (white surface, soft border, big radius).
 * Bottom tab bar is always rendered.
 */
export function MobileShell({ topBar, children, padBottom = true, hideTabs = false }) {
  return (
    <div
      className="min-h-screen w-full flex justify-center"
      style={{ background: "var(--te-bg-soft)" }}
    >
      <div
        className="
          relative w-full md:w-[440px] md:my-6 md:rounded-[36px] md:shadow-[0_30px_80px_-20px_rgba(103, 58, 183,0.25)] md:border md:border-[var(--te-divider)]
          bg-[var(--te-bg)] md:overflow-hidden
          min-h-screen md:min-h-[calc(100vh-3rem)] md:max-h-[920px]
          flex flex-col
        "
      >
        {topBar && (
          <header className="sticky top-0 z-30 te-mobile-header">
            {topBar}
          </header>
        )}
        <main
          className={`flex-1 overflow-y-auto te-no-scrollbar ${padBottom ? "pb-24" : ""}`}
        >
          {children}
        </main>
        {!hideTabs && <BottomTabBar />}
      </div>
    </div>
  );
}
